// extracted by mini-css-extract-plugin
export default {"bonus":"dsKqr","bonusRow":"cpVjt","bonusIcon":"IOr6u","bonusTooltip":"cK7zV"};